/**
 * Classe responsável pelas ações do grid para o servicetime updates
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 08/08/2013
 *
 */


Greenmile.ServiceTimeUpdates = Greenmile.ServiceTimeUpdates || {};
Greenmile.ServiceTimeUpdates.Grid = Greenmile.ServiceTimeUpdates.Grid || {};

Greenmile.ServiceTimeUpdates.Grid.ServiceTimeType = function () {

    Greenmile.ServiceTimeUpdates.Grid.apply(this, arguments);

    this.entity = 'ServiceTimeUpdatesServiceTimeType';
    this.entityToRequest = "ServiceTimeUpdServiceTimeType";
    this.collection = App.Collections.ServiceTimeUpdateServiceTimeTypes;

    this.getParams = function() {
        return {
            url : this.entityToRequest,
            data: {serviceTimeUpdServiceTimeTypes: [] },
            objName: 'serviceTimeUpdServiceTimeTypes'
        };
    };

};
